<div class="d-sm-block d-md-none">
    <div class="recipe-list">
        <span *ngFor="let recipe of dataService.recipeList$ | async">
            <app-recipe-list-item [data]="recipe" [routerLink]="['/recipe', recipe.id]"></app-recipe-list-item>
            <div style="height: 50px"></div>
        </span>
    </div>
</div>

<div class="d-none d-sm-none d-md-block">
    <div class="row justify-content-center">
        <span *ngFor="let recipe of dataService.recipeList$ | async">
            <app-recipe-list-item [data]="recipe" [routerLink]="['/recipe', recipe.id]"></app-recipe-list-item>
        </span>
    </div>
</div>